<script setup>
import Contact from '@sections/home/contact.vue'
</script>
<template>
	<Contact />
</template>
